import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';

import { JobService } from '../services/job.service';
import { Job } from '../../shared/models/job.interface';
import { JobType } from '../../shared/models/job.type.interface';
import { JobFilter } from '../models/job.filter';
import { User } from '../../shared/models/user.interface';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import {RolePermission } from '../../shared/models/role.permission.enum';

export interface DealerJobSummary {
  jobCount: number;
  salespersons: User[];
  jobTypes: JobType[];
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent {
  jobs: Job[];

  summary: DealerJobSummary;
  isFieldTech: boolean = false;

  filter: JobFilter = { salespersonId: '', jobTypeId: null, statusId: '1' } as JobFilter;

  constructor(protected jobService: JobService, deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);

    this.isFieldTech = JobService.hasPermission(RolePermission.FieldTechnician);
  }

  init() {
    this.loadSummary();
  }

  loadSummary() {
    this.jobService.getSummary(this.filter)
      .subscribe({
        next: (data) => {
          this.summary = data;
        },
        error: (error: string) => this.onError(error)
      });
  }  
}
